import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'
import { AtsApplicationPhaseListItemFragment } from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { EditApplicationPhase } from './EditApplicationPhase'

interface Props {
  applicationPhase: AtsApplicationPhaseListItemFragment
  onDelete: () => void
}

export const ApplicationPhaseListItem = ({ applicationPhase, onDelete }: Props) => {
  const [showEditPhase, setShowEditPhase] = React.useState(false)
  const applicationPhaseName = applicationPhase.name

  return (
    <>
      <Box
        flexDirection="row"
        justifyContent="spaceBetween"
        gap="s24"
        paddingY="s16"
        paddingRight="s24"
        paddingLeft="s12"
        width="full"
        alignItems="center"
      >
        <Box flexDirection="row" gap="s8" alignItems="center" flexGrow cursor="pointer">
          <Icon.Medium icon="drag-and-drop" color="grey400" />
          <Text.Normal weight="medium">{applicationPhaseName}</Text.Normal>
        </Box>

        <PopoverMenu type="list">
          <PopoverMenu.Trigger asChild>
            <Button
              type="secondary"
              iconName="ellipsis"
              aria-label={i18n.t('common.more_options')}
            />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="center">
            <PopoverMenu.TouchableOption
              title={i18n.t('common.edit')}
              onClick={() => setShowEditPhase(true)}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('common.destroy')}
              onClick={onDelete}
              danger
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>

      {showEditPhase && (
        <EditApplicationPhase
          id={applicationPhase.id}
          name={applicationPhaseName}
          hiringStageId={applicationPhase.atsHiringStageId}
          onClose={() => setShowEditPhase(false)}
        />
      )}
    </>
  )
}
